import React, { Component } from 'react'
import { connect } from "react-redux";
import { getUsers } from "../../store/actions";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import ItemView from './inventory-item';
import PurchaseOrders from './purchase-orders';
import SaleOrders from './sale-orders';
import ClockItems from './Clock-items';
import './style.scss';
class TimeInventoryView extends Component {


  async componentDidMount() {

  }

  render() {
    return (
      <>

        <h2 className="page_title">Time Clock Inventory</h2>
        <Tabs>
          <div className="tabNav d-flex align-items-center justify-content-between">
            <TabList>
              <Tab>Clocks & Parts</Tab>
              <Tab>Inventory Details</Tab>
              <Tab>Purchase Orders</Tab>
              <Tab>Sale Orders</Tab>
              <Tab>Warranties</Tab>
            </TabList>
          </div>
          <div className="tabContent">
            <TabPanel>
              <ClockItems></ClockItems>
            </TabPanel>
            <TabPanel>
              <ItemView></ItemView>
            </TabPanel>
            <TabPanel>
              <PurchaseOrders></PurchaseOrders>
            </TabPanel>
            <TabPanel>
              <SaleOrders></SaleOrders>
            </TabPanel>
          </div>
        </Tabs>
      </>
    )
  }
}

const mapStateToProps = ({ UserReducer, UsersReducer }) => ({ UserReducer, UsersReducer });
export default connect(mapStateToProps, { getUsers })(TimeInventoryView);